import React, { useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../styles/FloatingWhatsApp.css";

const FloatingWhatsApp = () => {
    const [showText, setShowText] = useState(false);

    useEffect(() => {
        const textTimer = setTimeout(() => {
            setShowText(true);
        }, 2000); // Muncul setelah 2 detik

        return () => clearTimeout(textTimer);
    }, []);

    const handleClick = () => {
        const phoneNumber = "+6285773745006";
        const whatsappUrl = `https://wa.me/${phoneNumber.replace("+", "")}`;
        window.open(whatsappUrl, "_blank");
    };

    return (
        <div className="floating-whatsapp" onClick={handleClick}>
            <FaWhatsapp className="whatsapp-icon" />
            {showText && <span className="whatsapp-text">Halo, ada yang bisa saya bantu? Silahkan klik ini untuk info & pemesanan.</span>}
        </div>
    );
};

export default FloatingWhatsApp;
